// removed by extract-text-webpack-plugin
module.exports = {"container":"Search-container","style":"Search-style","resetButton":"Search-resetButton","loaderContainer":"Search-loaderContainer"};